import * as actionType from "./actionTypes";

const getUserStart = () => {
  return {
    type: actionType.GET_USER_START,
  };
};

const getUserSuccess = (payload) => {
  return {
    payload: { ...payload },
    type: actionType.GET_USER_SUCCESS,
  };
};

// const getUserFail = (error) => {
//   return {
//     type: actionType.GET_USER_FAIL,
//     ...error,
//   };
// };

export const getUser = () => {
  return (dispatch) => {
    dispatch(getUserStart());

    const userData = {
      id: "1",
      username: "Okky Suardhana",
      email: "user@example.com",
      avatar: `https://i.pravatar.cc/100?u=${Math.random()}`,
      role: "admin",
      created_at: "2021-08-27T06:28:10.579Z",
      updated_at: "2021-08-27T06:28:10.579Z",
    };

    dispatch(getUserSuccess(userData));

    // dispatch(getUserFail(1 + 1));
  };
};
